import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "../../css/main-carousel.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const MainCarousel = ({
  images,
  titles = [],
  descriptions = [],
  size = "normal",
  settings = {},
}) => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    ...settings,
  };

  return (
    <div className={`main-carousel ${size}`}>
      <Slider {...sliderSettings}>
        {images.map((image, index) => (
          <div key={`main-carousel-item-${index}`} className="carousel-item">
            {React.cloneElement(image, {
              className: `carousel-item-image ${image.props.className || ""}`,
            })}
            <div className="carousel-item-about">
              {titles[index] && (
                <h3 className="carousel-item-title">{titles[index]}</h3>
              )}
              {descriptions[index] && (
                <p className="carousel-item-description">
                  {descriptions[index]}
                </p>
              )}
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default MainCarousel;
